import type { PcoHelpPageKey } from '@/config/resourcesPcoHelpCopy';
import { defineStore } from 'pinia';

/**
 * Estado do painel lateral de ajuda PCO — espelha o padrão do Customizer (drawer na raiz do v-app).
 */
export const usePcoPageHelpStore = defineStore('pcoPageHelp', {
    state: () => ({
        drawerOpen: false,
        helpKey: 'dashboard' as PcoHelpPageKey
    }),
    actions: {
        setHelpKey(key: PcoHelpPageKey) {
            this.helpKey = key;
        },
        openDrawer() {
            this.drawerOpen = true;
        },
        closeDrawer() {
            this.drawerOpen = false;
        }
    }
});
